import { registerDecorator, type ValidationOptions } from 'class-validator';
import { isAllowedLegalRefUrl } from './document-type-catalog.constants';

export function IsAllowedLegalRefUrl(validationOptions?: ValidationOptions): PropertyDecorator {
  return (target, propertyKey) => {
    registerDecorator({
      name: 'isAllowedLegalRefUrl',
      target: target.constructor,
      propertyName: String(propertyKey),
      options: {
        message: 'legalRefUrl must be an https link to EUR-Lex, Normattiva or Gazzetta Ufficiale',
        ...validationOptions,
      },
      validator: {
        validate: (value: unknown) => typeof value === 'string' && isAllowedLegalRefUrl(value),
      },
    });
  };
}
